import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://residere.codesky.com.br/api';

// Criar instância do axios
export const apiService = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token JWT em todas as requisições
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Configuração especial para uploads de arquivos
    if (config.data instanceof FormData) {
      // Remover Content-Type para que o browser defina automaticamente com boundary
      delete config.headers['Content-Type'];
      console.log('Upload detectado - Content-Type removido para FormData');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
apiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Função específica para upload de arquivos
export const uploadFiles = async (url: string, formData: FormData, onProgress?: (progress: number) => void) => {
  const token = localStorage.getItem('authToken');
  
  // Debug: verificar o que está sendo enviado
  console.log('=== DEBUG UPLOAD FILES ===');
  console.log('URL:', url);
  console.log('Token:', token ? 'Presente' : 'Ausente');
  console.log('FormData entries:');
  for (let [key, value] of formData.entries()) {
    if (value instanceof File) {
      console.log(`${key}: File(${value.name}, ${value.type}, ${value.size} bytes)`);
    } else {
      console.log(`${key}: ${value}`);
    }
  }
  
  const config = {
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      // Não definir Content-Type aqui - deixar o browser definir
    },
    onUploadProgress: (progressEvent: any) => {
      if (onProgress && progressEvent.total) {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(progress);
      }
    }
  };
  
  return apiService.post(url, formData, config);
};

// Função para salvar token e dados do usuário
export const saveAuthData = (token: string, userData: any) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('userData', JSON.stringify(userData));
};

// Função para limpar dados de autenticação
export const clearAuthData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
};

// Função para obter dados do usuário do localStorage
export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

// Função para verificar se está autenticado
export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};
